import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/types/blockDefinition';
import type { Action } from '@unifyapps/defs/types/action';
import type {
  BlockStateUnionType,
  BlockType,
  ComponentTypeUnionType,
} from '@unifyapps/defs/types/block';
import type { ButtonBlockStateType, ButtonComponentType } from '@unifyapps/defs/types/blocks';
import _pick from 'lodash/pick';
import Button from './Button';

class ButtonBlockStateDefinition implements BlockStateDefinition {
  getBlockVersion() {
    return 0;
  }

  get type(): ComponentTypeUnionType {
    return 'Button';
  }

  getBlockControlMethods() {
    return [
      {
        id: 'setDisabled' as const,
        label: 'Set Disabled',
        method: (blockState: BlockStateUnionType, action: Action) => {
          const { methodPayload } = action.payload as { methodPayload: { disabled: boolean } };

          const { disabled } = methodPayload;

          return {
            ...blockState,
            appearance: {
              ...blockState.appearance,
              disabled: {
                type: 'boolean',
                payload: disabled,
              },
            },
          } as ButtonBlockStateType;
        },
      },
    ];
  }

  get initialStateGetter() {
    return (block: BlockType) => ({
      id: block.id,
      ..._pick(block.component as ButtonComponentType, ['content', 'appearance', 'componentType']),
    });
  }

  getComponent() {
    return Button;
  }

  getSlotOrder(_block: BlockType): { order: string[] } {
    return {
      order: ['content', 'tooltip'],
    };
  }
}

export default ButtonBlockStateDefinition;
